import {Col, FormGroup, Label, Row} from "reactstrap";
import {I18n} from "../../I18n/components/promoter";
import React from "react";
import MultipleSelect from "../Common/MultipleSelect";

const StoresSelectRow = props => {
    return (
        <Row>
            <Col xs="12" md="12" lg="12">
                <FormGroup>
                    <Label for="stores">
                        {I18n[props.lang].stores}
                    </Label>
                    <MultipleSelect
                        name="storeIds"
                        selectedElementIds={props.storeIds}
                        elements={props.stores}
                        onChange={props.onStoresChange}
                    />
                </FormGroup>
            </Col>
        </Row>
    )
}

export default StoresSelectRow;


// WEBPACK FOOTER //
// ./src/components/Promoter/StoresSelectRow.js